module.exports = __webpack_public_path__ + "static/media/tamtam.d4d422e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/tamtam.svg?cciqt6
// module id = 659
// module chunks = 0